<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-01 09:06:58
 * @Descripttion:
-->
<template>
  <div class="footer">
    <div class="footer_All">
      <div class="footer-W">
        <p class="clearfix">
          <span
            ><img src="../../assets/pc/HomeTop/Home1.png" />Transformers
            Explorer</span
          >
          <span
            >Follow us
            <img
              :src="item.ImgUrl"
              v-for="(item, index) in list"
              :key="index"
              @click="Open(index)"
          /></span>
        </p>
        <p>©2024 - Transformers, Inc.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          ImgUrl: require("../../assets/pc/Footer/Footer3.png"),
        },
        {
          ImgUrl: require("../../assets/pc/Footer/Footer7.png"),
        },
        {
          ImgUrl: require("../../assets/pc/Footer/Footer5.png"),
        },
        {
          ImgUrl: require("../../assets/pc/Footer/Footer9.png"),
        },
        {
          ImgUrl: require("../../assets/pc/Footer/Footer1.png"),
        },
      ],
    };
  },
  methods: {
    Open(index) {
      if (index == 0) {
        window.open("https://medium.com/@transformerschain", "_blank");
      } else if (index == 1) {
        window.open("https://twitter.com/TFSCChain", "_blank");
      } else if (index == 2) {
        window.open("https://t.me/transformerschain", "_blank");
      } else if (index == 3) {
        window.open(
          "https://www.youtube.com/channel/UCxkH0sBwC9cASd3c3qwyvmA",
          "_blank"
        );
      } else if (index == 4) {
        // window.open("https://discord.com/invite/tfscchain001", "_blank");
        window.open("https://discord.com/invite/W4YsQduNrf", "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  background: #13161b;
  .footer_All {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .footer-W {
      width: 1160px;
      margin: 0 auto;
      // background: #232a35;
      padding: 20px 36px;
      border-radius: 16px 16px 0px 0px;
      p:nth-child(1) {
        height: 48px;
        span:nth-child(1) {
          float: left;
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 48px;
          -webkit-background-clip: text;
          img {
            width: 36px;
            height: 36px;
            margin-right: 14px;
            margin-top: 5px;
          }
        }
        span:nth-child(2) {
          float: right;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          // line-height: 48px;
          margin-top: 12px;
          -webkit-background-clip: text;
          display: inline-block;
          img {
            width: 24px;
            height: 24px;
            margin-left: 20px;
            cursor: pointer;
            // margin-top: 12px;
          }
        }
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        -webkit-background-clip: text;
        text-align: right;
        // margin-top: 28px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
